import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

import FeatureIcon from '../media/FeatureIcon.png'

const Main = (props) => {

    const infoFields = [
        {
            title: 'Name',
            key: 'name'
        },
        {
            title: 'Email',
            key: 'email'
        },
        {
            title: 'Zip Code',
            key: 'zip_code'
        },
        {
            title: 'Phone Number',
            key: 'phone_number'
        },
    ]

    const carFields = [
        {
            title: 'Brand',
            key: 'brand'
        },
        {
            title: 'Model',
            key: 'model'
        },
        {
            title: 'Trim',
            key: 'trim'
        },
        {
            title: 'Vehicle MSRP',
            key: 'msrp'
        },
        {
            title: 'Monthly Payment',
            key: 'monthly_payment'
        },
        {
            title: 'Due at Signing',
            key: 'due_at_signing'
        },
        {
            title: 'Term Length',
            key: 'term_length'
        },
        {
            title: 'Lease or Finance',
            key: 'loan_type'
        },
        {
            title: 'Yearly Milage',
            key: 'yearly_mileage'
        },
    ]

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_number:'',
        zip_code: '',
        brand: '',
        model: '',
        trim: '',
        msrp: '',
        monthly_payment: '',
        due_at_signing: '',
        term_length: '',
        loan_type:'',
        yearly_milage: '',
    })

    const handleDataChange = (key, value) => {
        setFormData(() => ({
            ...formData,
            [key]: value,
        }))
    }

    const [response, setResponse] = useState('')
    const [showResponse, setShowResponse] = useState(false)

    const submit = (formData) => {
        console.log(formData)
        var myHeaders = new Headers()
        myHeaders.append("Accept", "application/json")
        myHeaders.append("Content-Type", "application/json")

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(formData)
        }

        window.apiRequest('/contact/compare_lease', requestOptions, (result, status) => {   
            console.log(result)
            if (status === 200) {
                setResponse('Your message has been delivered. We will be in contact shortly.')
                setFormData({
                    name: '',
                    email: '',
                    phone_number:'',
                    zip_code: '',
                    brand: '',
                    model: '',
                    trim: '',
                    msrp: '',
                    monthly_payment: '',
                    due_at_signing: '',
                    term_length: '',
                    loan_type:'',
                    yearly_milage: '',
                })
            } else {
                setResponse('An error has occurred! Verify you have filled out all the required fields.')
            }
            setShowResponse(true) // Show response
            setTimeout(() => setShowResponse(false), 3000) // Hide after 3 seconds
        })
    }

    const handleKeyPress = (e, formData) => {
        if (e.key === 'Enter') {
            submit(formData)
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: 'auto', fontFamily: 'inter', color: window.colors.primary, ...props.style, textAlign: 'center'}}>
            <span style={{color: window.colors.primary, fontSize: '96px', fontWeight: '700'}}>Share Lease</span>
            <span style={{color: window.colors.muted, fontSize: '20px', fontWeight: '500', maxWidth: '600px', width: '90%', margin: 'auto', marginTop: '30px',}}>Share you're lease deal with us and we'll try to beat it!</span>
            <div style={{backgroundColor: window.colors.primary, display: 'flex', flexDirection: 'column', padding: '30px', maxWidth: '800px', width: '70%', margin: 'auto', borderRadius: '15px', marginTop: '50px'}}>
                <div style={{borderBottom: '1px solid ' + window.colors.border, textAlign: 'left', paddingBottom: '10px'}}>
                    <span style={{color: window.colors.white, fontSize: '24px', fontWeight: '700'}}>Share Lease</span>
                </div>
                <span style={{color: window.colors.muted, fontSize: '20px', fontWeight: '400', maxWidth: '600px', margin: 'auto', marginTop: '30px',}}>A representative from AutoVitus will contact you when we find the best offer for you.</span>
                <span style={{color: window.colors.white, textAlign: 'left', marginTop: '40px', fontSize: '20px', fontWeight: '600'}}>Contact Info</span>
                <div style={{display: 'grid', gridTemplateColumns: window.innerWidth < 900 ? 'repeat(1, 1fr)':'repeat(2, 1fr)', gap: '50px', marginTop: '20px', textAlign: 'left'}}>
                    {infoFields.map((item, index) => {
                        return (
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <span style={{fontWeight: '700', color: window.colors.white}}>{item.title}</span>
                                <input onChange={(e) => handleDataChange(item.key, e.target.value)} value={formData[item.key]} style={{marginTop: '10px', height: '40px', paddingLeft: '15px', fontSize: '16px', fontFamily: 'inter', fontWeight: '500', borderRadius: '5px', border: '0px'}}></input>
                            </div>
                        )
                    })}
                </div>
                <span style={{color: window.colors.white, textAlign: 'left', marginTop: '50px', fontSize: '20px', fontWeight: '600'}}>Vehicle Info*</span>
                <div style={{display: 'grid', gridTemplateColumns: window.innerWidth < 900 ? 'repeat(1, 1fr)':'repeat(2, 1fr)', gap: '50px', marginTop: '20px', textAlign: 'left'}}>
                    {carFields.map((item, index) => {
                        return (
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <span style={{fontWeight: '700', color: window.colors.white}}>{item.title}</span>
                                <input onChange={(e) => handleDataChange(item.key, e.target.value)} value={formData[item.key]} style={{marginTop: '10px', height: '40px', paddingLeft: '15px', fontSize: '16px', fontFamily: 'inter', fontWeight: '500', borderRadius: '5px', border: '0px'}}></input>
                            </div>
                        )
                    })}
                </div>
                <AnimatePresence>
                    {showResponse && (
                        <motion.span
                            initial={{ opacity: 0, y: 0 }}
                            animate={{ opacity: 1, y: 20 }}
                            exit={{ opacity: 0, y: 0 }}
                            transition={{ duration: 0.5 }}
                            style={{ marginTop: '0px', fontWeight: '500', fontSize: '16px', color: response.includes('error') ? 'red' : 'green'}}
                        >
                            {response}
                        </motion.span>
                    )}
                </AnimatePresence>
                <motion.button onClick={() => submit(formData)} whileHover={{width: '350px'}} style={{width: '300px', margin: 'auto', marginTop: '50px', backgroundColor: window.colors.white, fontFamily: 'inter', border: 'none', fontWeight: '600', fontSize: '16px', padding: '10px 5px 10px 5px', borderRadius: '5px', cursor: 'pointer'}}>Send</motion.button>
            </div>
           
        </div>
    );
}

export default Main;
